import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';


@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet><ng2-slim-loading-bar></ng2-slim-loading-bar>'
})
export class AppComponent implements OnDestroy {
    private sub: any;
    // Position of Ng2ToastyComponent
    private toastyComponentPosition: string;

    constructor(private slimLoader: SlimLoadingBarService, private router: Router) {
        // Listen the navigation events to start or complete the slim bar loading
        this.sub = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.slimLoader.progress = 30;
                console.log("slim loader started");
                console.log(this.slimLoader.progress);
                
            } else if ( event instanceof NavigationEnd ||
                        event instanceof NavigationCancel ||
                        event instanceof NavigationError) {
                this.slimLoader.complete();
            }
            if(event instanceof RouteConfigLoadStart ){
                this.slimLoader.progress = 30;
                console.log("slim loader route config started");
                console.log(this.slimLoader.progress);
            }
        }, (error: any) => {
            this.slimLoader.complete();
        });
    }

    ngOnDestroy(): any {
        this.sub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts